// @flow

export { default } from './KeydownPropagationBarrier';
